import React from "react";
import styles from "../css/EquipmentDetail.css";
import { request, origin } from "../request";
import { Toast, ActivityIndicator } from "antd-mobile";

class app extends React.Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }

  state = {
    title: "",
    manufactor: "",
    model: "",
    cs: "",
    yq: "",
    data: {
      top_image: "",
    },
    loading: true,
  };

  componentDidMount() {
    request(
      "index/getEquipmentDetail",
      { id: this.props.match.params.id },
      ({ data }) => {
        if (data.code === 1) {
          console.log(data.data);
          this.setState({
            data: data.data,
          });
          this.setState({
            title: data.data.name,
            manufactor: data.data.manufactor,
            model: data.data.model,
            cs: data.data.parameter,
            yq: data.data.requirement,
          });
        } else {
          Toast.fail("获取设备失败");
        }

        this.setState({
          loading: false,
        });
      }
    );
   
  }

  loading() {
    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: "rgba(0,0,0,0.2)",
          dispaly: "flex",
        }}
      >
        <ActivityIndicator
          toast
          text="正在加载"
          animating={this.state.loading}
        />
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          flex: 1,
          backgroundColor: "white",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {this.state.loading && this.loading()}
        <div className={styles.imgDiv}>
          <img
            // src={require("../static/fang.jpg")}
            src={origin + this.state.data.top_image}
            alt=""
            className={styles.img}
          ></img>
        </div>

        <div className={styles.info}>
          <span className={styles.name}>{this.state.title}</span>
          <div className={styles.tagList}>
            <div className={styles.tag}>
              <span className={styles.tagTitle}>
                仪器厂家：{this.state.manufactor}
              </span>
            </div>
            <div className={styles.tag}>
              <span className={styles.tagTitle}>
                仪器型号：{this.state.model}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.technicalParameter}>
          <div className={styles.technicalParameterTitle}>主要技术参数</div>
          {this.state.cs.split("&").map((val, index) => (
            <div key={index} className={styles.technicalParameterContent}>
              {index + 1}.{val}
            </div>
          ))}
        </div>

        <div className={styles.technicalParameter}>
          <div className={styles.technicalParameterTitle}>功能特色</div>

          {this.state.yq.split("&").map((val, index) => (
            <div key={index} className={styles.technicalParameterContent}>
              {index + 1}.{val}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default app;



// WEBPACK FOOTER //
// ./src/pages/EquipmentDetail.js